module.exports = __webpack_public_path__ + "img/background26.d243cf7a.jpg";